import React from "react";
import { AccordionSummary, AccordionSummaryProps, SxProps, Theme } from "@mui/material";

export type WcAccordionSummaryProps = AccordionSummaryProps & {
  
  sx?: SxProps<Theme>;
 
}

export const WcAccordionSummary = (props: WcAccordionSummaryProps) => (
  <AccordionSummary sx={props.sx} {...props} />
);

export default WcAccordionSummary;
